// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon.is-action i[data-v-bd32c368]{color:#2b3351}", ""]);
// Exports
module.exports = exports;
